import GraphicObject from './GraphicObject';

export default class Shader extends GraphicObject {

	constructor(gl, shaderType, data) {
		const shader = gl.createShader(shaderType);
		if (!shader) {
			throw new Error(`Failed to create shader of type ${shaderType}`);
		}
		if (data instanceof Array) {
			data = data.join('\n');
		}
		gl.shaderSource(shader, data);
		gl.compileShader(shader);
		if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
			console.log(data);
			console.error(gl.getShaderInfoLog(shader));
			throw new Error('Failed to compile shader');
		}
		super(gl, shader);
	}

	release() {
		this._gl.deleteShader(this._object);
		super.release();
	}

}
